export enum HolidayType{
  Paid = "Paid",
  NotPaid = "Not Paid",
  Medical = "Medical"
}
